"use strict"

module agi.expressions.card {
    export class Config {
        public static SCALE_FACTOR:number = 1;
        public static X_OFFSET:number = 0;
        public static Y_OFFSET:number = 0;
        public static IS_SQUARE:boolean = true;
        public static IS_PORTRAIT:boolean = false;
        public static IS_DESKTOP_VIEW = false;
        public static BASE_WIDTH = 1280;
        public static BASE_HEIGHT = 720;
        public static SQUARE_SIZE = 550;
        public static DESKTOP_CANVAS_WIDTH = 800;
        public static DESKTOP_FRAME_WIDTH = 960;
        public static DESKTOP_FRAME_HEIGHT = 800;
        public static ASSET_PATH = "";
        public static DEFAULT_PERS = {};
        public static IS_MOBILE = false;

        /**
         * Returns the width of the screen, taking portrait and landscape mode into consideration
         */
        public static CURRENT_WIDTH() : number{
            return Config.IS_PORTRAIT ? Config.BASE_HEIGHT : Config.BASE_WIDTH;
        }
        /**
         * Returns the height of the screen, taking portrait and landscape mode into consideration
         */
        public static CURRENT_HEIGHT() : number{
            return Config.IS_PORTRAIT ? Config.BASE_WIDTH : Config.BASE_HEIGHT;
        }
    }
}
